module.exports = __webpack_public_path__ + "static/img/hb.e7f486ff.jpg";